import { useCallback } from 'react'
import { useAppDispatch } from 'store/hooks'
import { useHistory, useParams } from 'react-router-dom'
import { replaceMessage } from 'uiComponents/messages/actions'
import { BaseRouteParams } from '../../../hocs'
import { useSelectedParkMapContext } from '../context/selectedParkMap'
import { Parkmap } from '../models'
import { useCreateParkMapMutation } from '../reduxQuery'
import { useParkMapViewerContext } from '../context/mapViewer'
import { useTranslation } from 'translations'

const useCreateMap = () => {
    const { t } = useTranslation()
    const [createParkMap, { isLoading }] = useCreateParkMapMutation()
    const { coords, zoom } = useParkMapViewerContext()
    const dispatch = useAppDispatch()
    const { accountSlug } = useParams<BaseRouteParams>()
    const history = useHistory()
    const { setSelectedParkMap } = useSelectedParkMapContext()

    const createMap = useCallback(
        async (parkmap: Parkmap) => {
            try {
                const response: any = await createParkMap({ parkMap: parkmap })

                if (response.data) {
                    setSelectedParkMap(response.data)
                    history.push(`/account/${accountSlug}/venue/park_map/${response.data.id}/details`)
                    dispatch(replaceMessage('create_park_map', 'success', t('venue.parkMap.messages.mapCreated'), 5000))
                } else {
                    dispatch(replaceMessage('create_park_map', 'error', t('venue.parkMap.messages.genericError'), 5000))
                }
            } catch (e) {
                dispatch(replaceMessage('create_park_map', 'error', e.message, 5000))
            }
        },
        [zoom, coords],
    )

    return { isLoading, createMap }
}

export default useCreateMap
